import Vue from 'vue'
import App from './App.vue'
import router from './router'
//import { i18n } from 'vue-lang-router';
import i18n from "./i18n";

import VueMeta from 'vue-meta';

import store from './store'

import VueContentPlaceholders from 'vue-content-placeholders'
import GTMVue from 'gtm-vue';
import * as GmapVue from 'gmap-vue';

import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

import {extend} from 'vee-validate';
import {required, min_value, max_value} from 'vee-validate/dist/rules';

import VueCardFormat from 'vue-credit-card-validation';

Vue.use(VueCardFormat);
Vue.use(VueMeta);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueContentPlaceholders);
Vue.use(GTMVue, {
    id: 'GTM-T9T62WJ',
    enabled: true,
    debug: false,
    router: router,
    ignoredViews: [],
    trackOnNextTick: false,
    disableDirective: false,
    directiveName: null,
});

Vue.use(GmapVue, {
    load: {
        key: process.env.VUE_APP_GOOGLE_APIKEY,
        libraries: [],
    },
    installComponents: true,
    autobindAllEvents: true,
});
Vue.component('font-awesome-icon', FontAwesomeIcon);

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/style.css'

Vue.config.productionTip = false;

// vee validate rules
extend('required', {
    ...required,
    validate(value) {
        return {
            required: true,
            valid: ['', null, undefined].indexOf(value) === -1
        };
    },
    computesRequired: true,
    message: 'This field is required'
});

extend('min_value', {
    ...min_value,
    message: 'Min value exceeded'
});

extend('max_value', {
    ...max_value,
    message: 'Max value exceeded'
});

var truncateFilter = function(text, length, clamp){
    clamp = clamp || '...';
    var node = document.createElement('div');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', truncateFilter);

new Vue({
    router,
    i18n,
    store,
    render: h => h(App)
}).$mount('#app');
